import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey:            'AIzaSyBKZCkVapbNUbaXbqQUKFL_fC-cMmNi4IY',
  authDomain:        'animal-stack-cb3e3.firebaseapp.com',
  projectId:         'animal-stack-cb3e3',
  storageBucket:     'animal-stack-cb3e3.firebasestorage.app',
  messagingSenderId: '221139768388',
  appId:             '1:221139768388:web:69f21d09bcf4603da4d811',
  measurementId:     'G-LKBJ29VR35',
};

const app = initializeApp(firebaseConfig);
export const db  = getFirestore(app);
